import * as React from "react";
import { LocationCreateForm } from "./form";

export const LocationCreateInitializer: React.FC = () => {
  return <LocationCreateForm />;
};
